import { glucoGenTestimonialsWithD } from "../../../data/testimonials";
import TestimonialsGallery from "../../common/testimonials-gallery";
import { mainPageLgTestimonials } from "../../../data/largeTestimonials";
import TestimonialsMessage from "../../common/testimonial-message";

const TestimonialsTsl = () => (
    <section id="testimonials" className="gg-bg-solid-green-light">
        <div className="container-fluid py-5">
            <div className="row justify-content-center align-items-center">
                <div className="col-11">
                    <div className="row justify-content-center align-items-center pb-3">
                        <div className="col-md-10 text-center">
                            <h2 className="fw-bold">It Wasn't Just Me.</h2>
                            <p>
                                Turns out, I wasn’t the first to walk through that back room door.<br />
                                Dr. Hart had been quietly working with people like me for years.<br />
                                People who had tried everything… and still felt like their bodies were working against them.
                            </p>
                            <h2 className="fw-bold">Real people. Real numbers.</h2>
                            <p>Real lives, quietly transformed by the same approach he was now offering me.</p>
                        </div>
                    </div>
                    <TestimonialsGallery
                        largeTestimonials={mainPageLgTestimonials} />
                    <TestimonialsMessage
                        testimonials={glucoGenTestimonialsWithD}
                    />
                    <div className="row justify-content-center align-items-center">
                        <div className="col-md-10 text-center">
                            <p className="fw-bold">And if you’re still here, still reading… Maybe you're meant to be one of them too.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
)

export default TestimonialsTsl;